/* iceberg-ui */
import { Box } from '@auviknetworks/iceberg-ui';

/*  React  */
import React from 'react';

/*  Components  */
import ReportHeader from '../Components/ReportHeader';
import { UsageBreakdown } from './UsageBreakdown';
import UsageDailyBreakdown from './UsageDailyBreakdown';
import { UsageOverview } from './UsageOverview';
import { UsageVsAdoption } from './UsageVsAdoption';

export const UsageReports = (props) => {
    const {
        renderingScheduledReport,
        reportData,
        reportSetup,
        reportWrapper,
        reportWrapperProps
    } = props;
    if (typeof reportData === 'undefined') {
        return null;
    }

    const { startTime, endTime, type } = reportSetup;

    return (
        <Box data-trackid="usageReportGridContainer" width="100%">
            {!reportWrapper && (
                <Box p="24px">
                    <ReportHeader
                        startDate={startTime}
                        endDate={endTime}
                        reportType={type}
                    />
                </Box>
            )}
            {/* organizational */}
            {reportData.organizationalUsageOverview && (
                <Box data-trackid="usageReportOrganizationalUsageOverviewWrapper">
                    <UsageOverview
                        renderingScheduledReport={renderingScheduledReport}
                        reportData={reportData.organizationalUsageOverview}
                        reportWrapper={reportWrapper}
                        reportWrapperProps={reportWrapperProps}
                    />
                </Box>
            )}
            {reportData.organizationalUsageOverviewBreakdown && (
                <Box data-trackid="usageReportOrganizationalUsageOverviewBreakdownWrapper">
                    <UsageBreakdown
                        renderingScheduledReport={renderingScheduledReport}
                        reportSetup={reportSetup}
                        reportData={
                            reportData.organizationalUsageOverviewBreakdown
                        }
                    />
                </Box>
            )}
            {reportData.organizationalUsageVsAdoption && (
                <Box data-trackid="usageReportOrganizationalUsageVsAdoptionWrapper">
                    <UsageVsAdoption
                        reportData={reportData.organizationalUsageVsAdoption}
                        reportWrapper={reportWrapper}
                        reportWrapperProps={reportWrapperProps}
                    />
                </Box>
            )}
            {reportData.organizationalUsageDailyBreakdown && (
                <Box
                    width="100%"
                    data-trackid="usageReportOrganizationalUsageDailyBreakdownWrapper"
                    className="break-before"
                >
                    <UsageDailyBreakdown
                        renderingScheduledReport={renderingScheduledReport}
                        reportSetup={reportSetup}
                        reportData={
                            reportData.organizationalUsageDailyBreakdown
                        }
                        reportWrapper={reportWrapper}
                    />
                </Box>
            )}
        </Box>
    );
};
